import { cn } from '../../lib/utils';

interface TabProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

export const Tab = ({ active, onClick, children, className }: TabProps) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'transition-colors duration-200 flex-1 text-center text-sm font-medium',
      active
        ? 'bg-accent-purple text-white'
        : 'text-subheading hover:bg-[#f5ede4]',
      className,
    )}
    aria-selected={active}
  >
    {children}
  </button>
);

interface TabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: { id: string; label: string }[];
  className?: string;
}

export const Tabs = ({
  activeTab,
  onTabChange,
  tabs,
  className,
}: TabsProps) => (
  <div className={cn('flex gap-1 p-1 rounded-lg', 'bg-[#fdf6ec]', className)}>
    {tabs.map((tab) => (
      <Tab
        key={tab.id}
        active={activeTab === tab.id}
        onClick={() => onTabChange(tab.id)}
        className="px-4 py-2 rounded-md"
      >
        {tab.label}
      </Tab>
    ))}
  </div>
);
